import { useApiUrl, useStaticFileUrl } from "@/config/url.js";
import CommonConfig from "@/config/common.js";
import SystemConfig from "@/config/system.js";

export default {
  ...CommonConfig,
  ...SystemConfig,
  apiUrl: useApiUrl,
  staticFileUrl: useStaticFileUrl,
  corporation: "汕头市友杏科技有限公司",
  siteName: "有杏管理系统",
  /** 租房图片上传目录（云盘文件夹ID，请在云盘中创建「租房图片」文件夹后填写） */
  rentalUploadCatalogId: 3681
};
